import requestCtxs from '@/sealFilter/requestCtxs'


//统计访问量
export function queryCountbyCondition (data) {
    return requestCtxs({
        url: '/whgs/api/queryCountbyCondition',
        method: 'post',
        data
    })
}

//添加网站访问量
export function InserPageView (data) {
    return requestCtxs({
        url: '/whgs/api/InserPageView',
        method: 'post',
        data
    })
}

//统计总访问量
export function querynyrCountbyCondition (data) {
    return requestCtxs({
        url: '/whgs/api/querynyrCountbyCondition',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/api/dataTotal.js